import { ADD_UPLOADING_FILE, REMOVE_UPLOADING_FILE, CLEAR_COMPLETED_STATUS_FILES, UPDATE_UPLOAD_PROGRESS } from "../mutation_types";


export const state = {
    uploadingFiles: []
};
  
export const getters = {
    getUploadingFiles: (state) => (folderId) => {
        if (!folderId) {
            return state.uploadingFiles;
        } else {
            return state.uploadingFiles.filter(file => file.folderId === folderId);
        }
    }
};

export const mutations =  {
    [ADD_UPLOADING_FILE] (state, payload) {

        if (!state.uploadingFiles.some(file => file.uid === payload.newFile.uid)) {
            const newUploadingFiles = [...state.uploadingFiles];

            newUploadingFiles.push(payload.newFile);

            state.uploadingFiles = newUploadingFiles
        }        
    },
    [REMOVE_UPLOADING_FILE] (state, payload) {
        const newUploadingFiles = [...state.uploadingFiles];
        const fileToRemoveIx = newUploadingFiles.findIndex(file => file.uid === payload.uid);
        newUploadingFiles.splice(fileToRemoveIx, 1);

        state.uploadingFiles = newUploadingFiles
    },
    [CLEAR_COMPLETED_STATUS_FILES] (state) {
        const newUploadingFiles = state.uploadingFiles.filter(file => {
            if (file.status === 'success' || file.status === 'exception') {
                return false;
            } else {
                return true;
            }
        });
        console.log(newUploadingFiles);
        state.uploadingFiles = newUploadingFiles;
    },
    [UPDATE_UPLOAD_PROGRESS] (state, payload) {
        const newUploadingFiles = [...state.uploadingFiles];
        const fileToUpdateIx = newUploadingFiles.findIndex(file => file.uid === payload.uid);

        if (payload.progress) {
            newUploadingFiles[fileToUpdateIx].progress = payload.progress;
        }
        if (payload.status) {
            newUploadingFiles[fileToUpdateIx].status = payload.status;
        }       
        state.uploadingFiles = newUploadingFiles;
    }
};
  
export const actions = {
    
};

export default {
    state,
    getters,
    mutations,
    actions
}
